import contextStorage from 'src/context/contextStorage';

const settingsStorage = JSON.parse(contextStorage() || 'null');

const getConfigValue = ({ envKey, settingKeys = [], fallback = '' }) => {
  if (process.env[envKey]) {
    return process.env[envKey];
  }

  for (let index = 0; index < settingKeys.length; index += 1) {
    const key = settingKeys[index];

    if (settingsStorage?.[key]) {
      return settingsStorage[key];
    }
  }

  return fallback;
};

let url;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  url = getConfigValue({
    envKey: 'REACT_APP_DOMAIN',
    settingKeys: ['apiUrl', 'API_URL'],
  });
} else {
  url = getConfigValue({
    envKey: 'REACT_APP_DOMAIN',
    settingKeys: ['apiUrl', 'API_URL'],
  });
}

export const APP_VERSION = process.env.REACT_APP_VERSION || '';
export const BASE_URL = url;
export const PORTAL_BPM_URL = getConfigValue({
  envKey: 'REACT_APP_PORTAL_BPM_URL',
  settingKeys: ['portalBpmUrl', 'PORTAL_BPM_URL'],
});
export const API_BASE_URL = `${BASE_URL}/api`;
export const DEBUG_BASE_URL = `${BASE_URL}/apm`;
export const SIGNALR_BASE_URL = `/SignalR`;
export const ENABLE_REDUX_LOGGER = false;

export const HUB_URL_COMMUNICATION = getConfigValue({
  envKey: 'REACT_APP_HUB_URL_COMMUNICATION',
  settingKeys: ['hubUrlCommunication', 'HUB_URL_COMMUNICATION'],
});
export const HUB_URL_IMPORT = getConfigValue({
  envKey: 'REACT_APP_HUB_URL_IMPORT',
  settingKeys: ['hubUrlImport', 'HUB_URL_IMPORT'],
});
export const HUB_URL_AUTH = getConfigValue({
  envKey: 'REACT_APP_HUB_URL_AUTH',
  settingKeys: ['hubUrlAuth', 'HUB_URL_AUTH'],
});
export const HUB_URL_ADMIN = getConfigValue({
  envKey: 'REACT_APP_HUB_URL_ADMIN',
  settingKeys: ['hubUrlAdmin', 'HUB_URL_ADMIN'],
});
export const HUB_URL_INTEGRATION = getConfigValue({
  envKey: 'REACT_APP_HUB_URL_INTEGRATION',
  settingKeys: ['hubUrlIntegration', 'HUB_URL_INTEGRATION'],
});

export const MODULE = {
  hub: { location: '/hub', name: 'Hub', type: 'hub' },
  admin: { location: '/admin', name: 'admin', type: 'admin' },
};

export default {};
